import{__require as r}from"./is-null-or-undefined.js";var e,n;function o(){if(n)return e;n=1;var o=r(),t=TypeError;return e=function(r){if(o(r))throw new t("Can't call method on "+r);return r}}export{o as __require};
//# sourceMappingURL=require-object-coercible.js.map
